import './Contatti.css';
import '../header/GlobalButton.css'

const Contatti = () => {

  return (
    <div class="max-h-[calc(100vh-86px)] overflow-y-auto flex flex-col justify-between h-full">
        <main class="max-w-6xl mx-auto w-full px-4 py-8">
            <header class="text-center mb-8">
                <h1 class="text-3xl font-serif mb-2 tracking-wide">Mettiti in Contatto</h1>
                <p class="text-stone-500 text-sm italic">Pianifica il tuo appuntamento privato.</p>
            </header>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
                <div class="space-y-4 text-sm">
                    <div>
                        <h3 class="text-xs uppercase tracking-widest text-stone-400 font-semibold mb-1">Indirizzo</h3>
                        <p class="text-stone-700">Via XXX, 12 - Roma</p>
                    </div>
                    <div>
                        <h3 class="text-xs uppercase tracking-widest text-stone-400 font-semibold mb-1">Diretti</h3>
                        <p class="text-stone-700">info@info.it</p>
                    </div>
                    <div class="bg-stone-200 h-[150px] w-full flex items-center justify-center text-stone-500 font-serif italic text-xs">
                        Mockup Mappa
                    </div>
                </div>

                <div class="bg-white p-6 border border-stone-200 shadow-sm">
                    <div class="space-y-4">
                        <div>
                            <label class="block text-xs uppercase tracking-wider text-stone-500 mb-1" for="name">Nome</label>
                            <input class="w-full bg-stone-50 border border-stone-200 px-3 py-1.5 text-sm focus:outline-stone-400" type="text" id="name" required />
                        </div>
                        <div>
                            <label class="block text-xs uppercase tracking-wider text-stone-500 mb-1" for="message">Messaggio</label>
                            <textarea class="w-full bg-stone-50 border border-stone-200 px-3 py-1.5 text-sm focus:outline-stone-400 h-20" id="message" required></textarea>
                        </div>
                        <a href='#' className="button button--janus"><span>Invia</span></a>
                    </div>
                </div>
            </div>
        </main>

    </div>
  );
};

export default Contatti;
